import { render, staticRenderFns } from "./EditTeacher.vue?vue&type=template&id=05ca4f5a&scoped=true&"
import script from "./EditTeacher.vue?vue&type=script&lang=js&"
export * from "./EditTeacher.vue?vue&type=script&lang=js&"
import style0 from "./EditTeacher.vue?vue&type=style&index=0&id=05ca4f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ca4f5a",
  null
  
)

export default component.exports